import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Divider, SxProps, Theme } from "@mui/material";

interface AccordionProps {
  title: string | React.ReactNode;
  component: React.ReactNode;
  extendedByDefault?: boolean;
  sx?: SxProps<Theme>;
  titleSx?: SxProps<Theme>;
}

export default function NzcAccordion(props: Readonly<AccordionProps>) {
  return (
    <Accordion
      defaultExpanded={props.extendedByDefault}
      sx={props.sx}
      elevation={0}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon sx={{ color: "primary.main" }} />}
        aria-controls="panel1-content"
        id="panel1-header"
      >
        <Typography sx={props.titleSx}>
          {props.title}
        </Typography>
      </AccordionSummary>
      <Divider />
      <AccordionDetails>{props.component}</AccordionDetails>
    </Accordion>
  );
}
